import { EInsufficientVersionException } from "../../../../Cryptography/Crypto/CryptoExceptions";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IContentBuilder } from "./IContentBuilder";
/**
 * @internal
 */
export class CryptoVersionInfoBuilder implements IContentBuilder {
    private _content: HTMLElement;
    private _versionException: EInsufficientVersionException;

    constructor(exception: EInsufficientVersionException) {
        this._versionException = exception;
    }

    private async _buildMessageElement(): Promise<void> {
        const contentDiv = createElement({ classes: "crypto-version-info-content" });

        if (!this._versionException.extensionVersionSufficient) {
            const extensionVersionMessageDiv = createElement({ classes: "extension-version-message" });
            contentDiv.appendChild(extensionVersionMessageDiv);

            const extensionVersionMainMessage = createElement({ classes: "version-main-message" });
            extensionVersionMainMessage.innerText = await Localization
                .getTextPromise("GUI-621094"); // Je potřeba aktualizovat vaše Crypto Web Extension rozšíření prohlížeče

            const extensionVersionRequired = createElement({ classes: "version-required" });
            extensionVersionRequired.innerText = await Localization
                .getTextPromiseWithParams("GUI-621096", [this._versionException.requiredExtensionVersion]); // Minimální vyžadovaná verze: @0

            const extensionVersionInstalled = createElement({ classes: "version-installed" });
            extensionVersionInstalled.innerText = await Localization
                .getTextPromiseWithParams("GUI-621097", [this._versionException.installedExtensionVersion]); // Nainstalovaná verze: @0

            extensionVersionMessageDiv.appendChild(extensionVersionMainMessage);
            extensionVersionMessageDiv.appendChild(extensionVersionRequired);
            extensionVersionMessageDiv.appendChild(extensionVersionInstalled);

            const extensionVersionUpdate = createElement({ classes: "version-update" });
            extensionVersionUpdate.innerText = await Localization
                .getTextPromise("GUI-621098"); // Aktuální verzi si můžete stáhnout na:
            const extensionVersionUpdateLink = createElement({
                type: "a",
                value: "Crypto Web Extension",
                attrs: { href: this._versionException.extensionUpdateURL, target: "_blank" },
            });
            extensionVersionUpdate.appendChild(extensionVersionUpdateLink);

            extensionVersionMessageDiv.appendChild(extensionVersionUpdate);
        }

        if (!this._versionException
            .extensionVersionSufficient &&
            !this._versionException.nativeAppVersionSufficient) {
            const messageSeparator = createElement({ classes: "version-message-separator" });
            contentDiv.appendChild(messageSeparator);
        }

        if (!this._versionException.nativeAppVersionSufficient) {
            const nativeAppVersionMessageDiv = createElement({ classes: "native-version-message" });
            contentDiv.appendChild(nativeAppVersionMessageDiv);

            const nativeAppVersionMainMessage = createElement({ classes: "version-main-message" });
            nativeAppVersionMainMessage.innerText = await Localization
                .getTextPromise("GUI-621095"); // Je potřeba aktualizovat vaši Crypto Native App aplikaci

            const nativeAppVersionRequired = createElement({ classes: "version-required" });
            nativeAppVersionRequired.innerText = await Localization
                .getTextPromiseWithParams("GUI-621096", [this._versionException.requiredNativeAppVersion]); // Minimální vyžadovaná verze: @0

            const nativeAppVersionInstalled = createElement({ classes: "version-installed" });
            nativeAppVersionInstalled.innerText = await Localization
                .getTextPromiseWithParams("GUI-621097", [this._versionException.installedNativeAppVersion]); // Nainstalovaná verze: @0

            nativeAppVersionMessageDiv.appendChild(nativeAppVersionMainMessage);
            nativeAppVersionMessageDiv.appendChild(nativeAppVersionRequired);
            nativeAppVersionMessageDiv.appendChild(nativeAppVersionInstalled);

            const nativeAppVersionUpdate = createElement({ classes: "version-update" });
            nativeAppVersionUpdate.innerText = await Localization
                .getTextPromise("GUI-621098"); // Aktuální verzi si můžete stáhnout na:
            const nativeAppVersionUpdateLink = createElement({
                type: "a",
                value: "Crypto Native App",
                attrs: { href: this._versionException.nativeAppUpdateURL, target: "_blank" },
            });
            nativeAppVersionUpdate.appendChild(nativeAppVersionUpdateLink);

            nativeAppVersionMessageDiv.appendChild(nativeAppVersionUpdate);
        }

        this._content = contentDiv;
    }

    public async build(): Promise<HTMLElement> {
        await this._buildMessageElement();
        return this._content;
    }
}
